import { render, staticRenderFns } from "./s_ChangePassword.vue?vue&type=template&id=097483f5&scoped=true&"
import script from "./s_ChangePassword.vue?vue&type=script&lang=js&"
export * from "./s_ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./s_ChangePassword.vue?vue&type=style&index=0&id=097483f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097483f5",
  null
  
)

export default component.exports